import { useTranslation } from "react-i18next";
import { User } from "../../services/user/userModel";
import { userService } from "../../services/user/userService";
import { useState } from "react";
import { loggerBuilder } from "../../services/logger";
import { toastsWithIntl } from "../../services/toastService";

const PremiumSection = ({ user }: { user: User }) => {
  const { getCustomerPortalUserLink } = userService();
  const { t } = useTranslation();
  const logger = loggerBuilder("PremiumSection");
  const { toastError } = toastsWithIntl(["common"]);
  const [loadingPortal, setLoadingPortal] = useState(false);
  return (
    <div>
      <h2 className="section_title">{t("accounts:premium.SECTION_TITLE")}</h2>
      <div className="lblock">
        <p>{t("accounts:premium.SECTION_SUBTITLE")}</p>
        <div className="lblock--l --txt--center">
          <button
            className="btn--2"
            disabled={loadingPortal}
            onClick={() => {
              const handlePortalLink = async () => {
                try {
                  setLoadingPortal(true);
                  const result = await getCustomerPortalUserLink(user.id);
                  if (result?.url) window.location.href = result.url;
                } catch (err) {
                  logger.error(
                    "Erreur lors de la récupération du lien premium",
                    err,
                  );
                  toastError("common:error.header.PREMIUM_LINK_ERROR");
                  return;
                } finally {
                  setLoadingPortal(false);
                }
              };

              void handlePortalLink();
            }}
          >
            {loadingPortal
              ? "..."
              : t("accounts:premium.MANAGE_SUBSCRIPTION_BUTTON")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumSection;
